var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mt-15 pt-10"},[_c('login-component-layout',{attrs:{"component":_vm.reason}},[_c('v-form',{on:{"submit":function($event){$event.preventDefault();return _vm.backToLogin.apply(null, arguments)}}},[_c('login-component-submit-button',{attrs:{"isFormValid":true,"component":_vm.reason}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }